<template lang="pug">
    d2-container
      el-form(:inline='true', :model='dataForm'  size='mini' label-position='right' label-width='75px' label-suffix=':')
        el-row(:span='24')
          el-col(:md='6' :sm='12')
             el-form-item(label='账号')
                el-input.inputWidth(v-model='dataForm.account', placeholder='账号', clearable='')
          el-col(:md='6' :sm='12')
             el-form-item(label='姓名' )
                el-input.inputWidth(v-model='dataForm.userName', placeholder='姓名', clearable='')
          el-col(:md='6' :sm='12')
             el-form-item(label='主办方')
                el-select.inputWidth(v-model="dataForm.orgId",placeholder="请选择" filterable clearable)
                    el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
        el-row(:span='24')
          el-col(:md='6' :sm='12')
             el-form-item(label='比赛类别' v-if="type === 1")
                el-select.inputWidth(v-model='dataForm.busType' clearable)
                   el-option(label="青少年比赛" value=-1)
                   el-option(label="分级公开赛" value=1)
                   el-option(label="俱乐部公开赛" value=2)
             el-form-item(label='培训类别' v-if="type === 2")
                el-select.inputWidth(v-model='dataForm.busType' clearable)
                   el-option(label="分级单次培训" value=3)
                   el-option(label="分级整期培训" value=4)
                   el-option(label="青少年儿童培训" value=5)
                   el-option(label="个人定制化培训" value=6)
                   el-option(label="团体定制化培训" value=7)
          el-col(:md='6' :sm='12')
             el-form-item(label='申请日期')
                 el-date-picker(style='width:210px', v-model='dataForm.applyTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
          el-col(:span='24' style="padding-bottom:15px;")
            el-button(@click="exportExcel()" type="primary") 导出报表
            el-button(@click='getDataList()',type='primary',icon='el-icon-search' style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='userName' header-align='center',align='center',label='姓名')
            el-table-column(prop='account' header-align='center',align='center',label='账号'  width="120")
            el-table-column(prop='busType' header-align='center',align='center',label='比赛类别' v-if="type === 1")
                template(slot-scope="scope")
                    font(v-if='scope.row.busType === -1') 青少年比赛
                    font(v-if='scope.row.busType === 1') 分级公开赛
                    font(v-if='scope.row.busType === 2') 俱乐部公开赛
            el-table-column(prop='busType' header-align='center',align='center',label='培训类别' v-if="type === 2")
                template(slot-scope="scope")
                    font(v-if='scope.row.busType === 3') 分级单次培训
                    font(v-if='scope.row.busType === 4') 分级整期培训
                    font(v-if='scope.row.busType === 5') 青少年儿童培训
                    font(v-if='scope.row.busType === 6') 个人定制化培训
                    font(v-if='scope.row.busType === 7') 团体定制化培训
            el-table-column(prop='orgName' header-align='center',align='center',label='主办方')
            el-table-column(prop='busName' header-align='center',align='center',label='比赛名称' v-if="type === 1")
            el-table-column(prop='busName' header-align='center',align='center',label='培训名称' v-if="type === 2")
            el-table-column(prop='busId' header-align='center',align='center',label='比赛ID')
            el-table-column(prop='createTime' header-align='center',align='center',label='申请时间' sortable)
            el-table-column(prop='payAmount' header-align='center',align='center',label='支付金额')
                template(slot-scope="scope")
                    font(v-if='scope.row.payAmount')
                      span() ¥ {{parseFloat(scope.row.payAmount).toFixed(2)}} 元
            el-table-column(prop='refundScale' header-align='center',align='center',label='退款比例')
                template(slot-scope="scope")
                    font(v-if='scope.row.refundScale!=null')
                      span() {{scope.row.refundScale}} %
            el-table-column(prop='refundAmount' v-if="refundAmount" header-align='center',align='center',label='退款金额')
                template(slot-scope="scope")
                    font(v-if='scope.row.refundAmount')
                      span() ¥ {{parseFloat(scope.row.refundAmount).toFixed(2)}} 元
            el-table-column(prop='refundFee' v-if="!refundAmount" header-align='center',align='center',label='退款金额')
                template(slot-scope="scope")
                    font(v-if='scope.row.refundFee')
                      span() ¥ {{parseFloat(scope.row.refundFee).toFixed(2)}} 元
            el-table-column(prop='payStatus' header-align='center',align='center',label='状态')
                template(slot-scope="scope")
                    font(v-if='scope.row.payStatus === 0')
                      span.danger()
                      span() &nbsp; 未支付
                    font(v-if='scope.row.payStatus === 1')
                      span.warning()
                      span() &nbsp; 支付中
                    font(v-if='scope.row.payStatus === 2')
                      span.success()
                      span() &nbsp; 支付成功
                    font(v-if='scope.row.payStatus === 3')
                      span.danger()
                      span() &nbsp; 支付失败
                    font(v-if='scope.row.payStatus === 4')
                      span.danger()
                      span() &nbsp; 超时
                    font(v-if='scope.row.payStatus === 5')
                      span.danger()
                      span() &nbsp; 申请退款
                    font(v-if='scope.row.payStatus === 6')
                      span.warning()
                      span() &nbsp; 退款中
                    font(v-if='scope.row.payStatus === 7')
                      span.success()
                      span() &nbsp; 退款成功
                    font(v-if='scope.row.payStatus === 8')
                      span.danger()
                      span() &nbsp; 退款失败
                    font(v-if='scope.row.payStatus === 9')
                      span.danger()
                      span() &nbsp; 支付已关闭
                    font(v-if='scope.row.payStatus === 10')
                      span.warning()
                      span() &nbsp; 退款已取消
            el-table-column(prop="refundDesc" header-align="center",align="center",label="退款原因")
              template(slot-scope="scope")
                span() {{ refundDesc_Com(scope.row.refundDesc) }}
            el-table-column(prop='remark' header-align='center',align='center',label='备注' v-if="type === 2")
            el-table-column(prop='',header-align='center',align='center',label='操作')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1"   @click="confirmRefund(scope.row.id)" :disabled='scope.row.payStatus!==5' v-if="isAuth('cb:competitionRefund:agree')" ) 确认退款
                                el-menu-item(index="1-2"   @click="returnApply(scope.row.id)" :disabled='scope.row.payStatus!==5'   v-if="isAuth('cb:competitionRefund:apply')" ) 退回申请

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')

</template>
<script>
import table from './table.js'
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'finance-refundManage-competitionRefund',
  props: ['orderType', 'type'],
  data () {
    return {
      // 导出报表
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      dataForm: {
        orgId: null, //主办方
        busId: '',
        account: '',
        userName: '',
        applyTime: '',
        busType: null,
        orderType: null,
        payStatus: null
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      sysOrgList: [],
      dataListLoading: false
    }
  },
  computed: {
    // 退款原因截取前30个字符
    refundDesc_Com () {
      return function (str) {
        if (str) {
          if (str.length > 30) {
            return `${str.slice(0, 30)}...`
          } else {
            return str
          }
        } else {
          return '-'
        }
      }
    }
  },
  mounted () {
    this.dataForm.applyTime = get30DaysArray()
    this.getDataList()
    this.initOrgList()
  },
  methods: {
      //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 获取数据列表
    getDataList () {
      console.log(this.dataListLoading)
      this.dataListLoading = true
      let startTime = null
      let endTime = null
      if (this.dataForm.applyTime !== null) {
        if (this.dataForm.applyTime.length > 0) {
          startTime = this.dataForm.applyTime[0]
          endTime = this.dataForm.applyTime[1]
        }
      }
      this.$http({
        url: this.$http.adornUrl('/payRefund/list'),
        method: 'POST',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          orgId: this.dataForm.orgId, //主办方
          busId: this.dataForm.busId,
          account: this.dataForm.account,
          userName: this.dataForm.userName,
          startTime: startTime,
          endTime: endTime,
          payStatus: this.dataForm.payStatus,
          busType: this.dataForm.busType, //赛事类型
          orderType: this.orderType
        })
      }).then(data => {
        console.log(data)
        if (data && data.code === 0) {
          this.tableData = data.page.rows
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initOrgList () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    confirmRefund (id) {
      console.log('确认退款', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/confirmRefund'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then(data => {
        if (data.code == 0) {
          this.$message.success('退款成功!')
          this.getDataList()
        } else {
          this.$message.success('退款失败!')
        }
      })
    },
    returnApply (id) {
      console.log('退回申请', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/returnApply'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then(data => {
        if (data.code == 0) {
          this.$message.success('退回申请成功!')
          this.getDataList()
        } else {
          this.$message.success('退回申请失败!')
        }
      })
    },
    //导出报表
    exportExcel () {
      let startTime = null
      let endTime = null
      if (this.dataForm.applyTime !== null) {
        if (this.dataForm.applyTime.length > 0) {
          startTime = this.dataForm.applyTime[0]
          endTime = this.dataForm.applyTime[1]
        }
      }
      this.$http({
        url: this.$http.adornUrl('/payRefund/list'),
        method: 'POST',
        params: this.$http.adornParams({
          page: 1,
          rows: 100000,
          orgId: this.dataForm.orgId, //主办方
          busId: this.dataForm.busId, // 比赛ID
          account: this.dataForm.account, // 账号
          userName: this.dataForm.userName, // 姓名
          startTime: startTime, // 开始时间
          endTime: endTime, // 结束时间
          payStatus: this.dataForm.payStatus, // 支付状态
          busType: this.dataForm.busType, //赛事类型
          orderType: this.orderType, // 订单类型
          downLoad: true
        })
      }).then(data => {
        if (data && data.code === 0) {
          // 为空判断
          if (data.page.rows == null || data.page.rows.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }

          // 数据转化
          let exportData = data.page.rows
          for (let i of exportData) {
            // 竞赛
            if (this.type === 1) {
              i.__busType__ = {
                '-1': '青少年比赛',
                1: '分级公开赛',
                2: '俱乐部公开赛'
              }[i.busType]
            }
            // 培训
            if (this.type === 2) {
              i.__busType__ = {
                3: '分级单次培训',
                4: '分级整期培训',
                5: '青少年儿童培训',
                6: '个人定制化培训',
                7: '团体定制化培训'
              }[i.busType]
            }
            // 退款金额
            i.refundAmount = i.refundAmount || i.refundFee
            // 退款状态
            i.__payStatus__ = {
                0: '未支付',
                1: '支付中',
                2: '支付成功',
                3: '支付失败',
                4: '超时',
                5: '申请退款',
                6: '退款中',
                7: '退款成功',
                8: '退款失败',
                9: '支付已关闭',
                10: '退款已取消'
              }[i.payStatus]
          }

          // 调整表格表头字段
          this.table.columns.forEach(item => {
            if (item.prop === 'busName') {
              if (this.type === 1) {
                item.label = '比赛名称'
              }
              if (this.type === 2) {
                item.label = '培训名称'
              }
            }
            if (item.prop === '__busType__') {
              if (this.type === 1) {
                item.label = '比赛类别'
              }
              if (this.type === 2) {
                item.label = '培训类别'
              }
            }
          })

          // 导出表格
          this.$export.excel({
            columns: this.table.columns,
            data: exportData,
            title: `${this.type === 1 ? '竞赛' : '培训'}退款报表`
          }).then(() => {
            this.$message.success(`${this.type === 1 ? '竞赛' : '培训'}退款报表导出成功`)
          })
        }
      })
    }
  }
}
</script>
<style>
.inputWidth {
  width: 210px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
  /* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';
</style>
